import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";
import _ from "lodash";
import type { TopUp } from "../types/payouts.type";

const CONFIRMING_WINDOW_MS = 15 * 60 * 1000;

const newestFirst = (topUps: TopUp[] = []) =>
  _.orderBy(topUps, "createdAt", "desc");

export const isConfirmingPayment = (topUp?: TopUp) =>
  topUp?.status === "pending" &&
  Date.now() - Date.parse(topUp.createdAt) < CONFIRMING_WINDOW_MS;

export function useFetchBatchTopUps(batchId: string | null) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const { data } = useQuery(
    trpc.topUps.list.queryOptions(
      { rentalsMerchantId: merchant?.id ?? "", batchId: batchId ?? "" },
      {
        enabled: !!merchant?.id && !!batchId,
        refetchInterval: (query) =>
          isConfirmingPayment(newestFirst(query.state.data?.data)[0])
            ? 5000
            : false,
      }
    )
  );

  const topUps = newestFirst(data?.data);
  return {
    latest: topUps[0],
    approved: topUps.find((topUp) => topUp.status === "approved"),
  };
}
